import _ from 'lodash';
import {
  call,
  put,
  select,
  fork,
  takeLatest
} from 'redux-saga/effects';
import { browserHistory } from 'react-router';
import { getFormValues } from 'redux-form';
import loader from '../../../../../util/loader/loader';
import dataProvider from '../../../../../util/dataProvider/dataProvider';
import { navigationRoutes, navigationSteps } from '../../../navigation/navigationHelpers';
import { removeNonDigits } from '../../../../../util/form/normalization';
import { SET_DATA, customerSelector } from '../../../data/customer/customer';
import {
  LOAD_CONTENT,
  SUBMIT_ORDER,
  DL_PAGE_LOADED
} from './specialist';
import {
  showGlobalSpinner,
  hideGlobalSpinner,
  errorPageByFlow
} from '../../../common/common';

// WATCHERS
export function* loadCustomerWatch() {
  yield takeLatest(LOAD_CONTENT, loadCustomerWorker);
}

export function* submitOrderWatch() {
  yield takeLatest(SUBMIT_ORDER, submitOrderWorker);
}

// WORKERS
export function* loadCustomerWorker() {
  try {
    yield put(showGlobalSpinner({hideContent: true}));

    const errorPage = yield select(errorPageByFlow);
    const success = yield call(dataProvider.load, [
      {state: 'auth'},
      {state: 'customer'},
      {state: 'context'}
    ], {errorPage});

    if (!success) {
      return;
    }

    yield put({
      type: DL_PAGE_LOADED
    });

    yield put(hideGlobalSpinner());
  } catch(e) {
    yield put(hideGlobalSpinner());
    browserHistory.push(navigationRoutes[navigationSteps.movers.ERROR].path);
  }
}

export function* submitOrderWorker() {
  const errorPage = yield select(errorPageByFlow);

  try {
    const values = yield select(getFormValues('specialist'));
    const customer = yield select(customerSelector);
    const data = {
      acceptedContractIds: null,
      isVerified: true,
      preferredTelephoneNumber: removeNonDigits(values.phoneNumber),
      orderType: "MoveTransfer"
    };

    const postLoad = function* () {
      const customerWithUpdates = {
        customer: {
          ...customer,
          phoneNumber: _.get(data, 'phoneNumber')
        }
      };

      yield put({
        type: SET_DATA,
        payload: customerWithUpdates
      });
    };

    const endpoint = navigationRoutes[navigationSteps.movers.SPECIALIST].endpoints.submitOrder();

    yield put(showGlobalSpinner({hideContent: false}));
    yield call(loader.request, endpoint, {data, useGlobalSpinner: false, postLoad, postLoadOnError: false, errorPage});
    yield put(hideGlobalSpinner());
  } catch(e) {
    //console.info(e);
    if (e.message === 'cancel(task): argument task is undefined') {
      return;
    }

    yield put(hideGlobalSpinner());

    const receivedErrorResponse = e.data && e.data.responseStatus === "Error";

    if (!receivedErrorResponse) {
      browserHistory.push(errorPage);
    }
  }
}

export default function* moversSpecialistSagas() {
  yield [
    fork(loadCustomerWatch),
    fork(submitOrderWatch)
  ];
}



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/Movers/specialist/specialistSagas.js
 **/